import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TasksPopoverComponent } from './task-popover/task-popover.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ActionButtonModule } from 'app/shared/components/action-button/action-button.module';
import { TasksOverviewComponent } from './tasks-overview/tasks-overview.component';
import { NavigationModule } from 'app/shared/navigation/navigation.module';
import { TasksRoutingModule } from './tasks.routing';
import { TableModule } from 'app/shared/components/table/table.module';
import { MomentModule } from 'ngx-moment';
import { DynamicTranslationModule } from 'app/shared/dynamic-translation/dynamic-translation.module';

@NgModule({
  imports: [
    CommonModule,
    ActionButtonModule,
    NavigationModule,
    TasksRoutingModule,
    TableModule,
    MomentModule,
    DynamicTranslationModule
  ],
  declarations: [
    TasksPopoverComponent,
    ProgressBarComponent,
    TasksOverviewComponent
  ],
  exports: [TasksPopoverComponent]
})
export class TasksModule {}
